import { render, staticRenderFns } from "./CapacitanceItems.vue?vue&type=template&id=4d3b5516&scoped=true&"
import script from "./CapacitanceItems.vue?vue&type=script&lang=js&"
export * from "./CapacitanceItems.vue?vue&type=script&lang=js&"
import style0 from "./CapacitanceItems.vue?vue&type=style&index=0&id=4d3b5516&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b5516",
  null
  
)

export default component.exports